// extracted by mini-css-extract-plugin
export default {"container":"bX_d","image":"bX_dy","title":"bX_c0","description":"bX_cM","button":"bX_dS"};